var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('material-billing-details-card',{attrs:{"client-id":_vm.clientId}}),_c('material-billing-contact-details-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }